const axios = require("axios");
export default {
  data() {
    return {
      email: null,
      success: null,
      error: null,
    };
  },
  computed: {
    signupValid() {
      let re =
        /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)])/;
      return this.email && this.email.match(re);
    },
  },
  methods: {
    submitNewsletterRegistration() {
      axios
        .post("https://contact.frechdax-abdl.de/api/newsletter/register", {
          email: this.email,
          origin: window.location.hostname,
        })
        .then((response) => response.data)
        .then(() => {
          this.success = true;
        })
        .catch((error) => {
          console.error(error);
          this.error = error.response.data;
        });
    },
  },
};
